import React from "react";
import PropTypes from "prop-types";

const ClockIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  ...props
}) => {
  const resolvedStroke = stroke || color || "currentColor";

  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M1.66602 10.0003C1.66602 14.5996 5.40006 18.3337 9.99935 18.3337C14.5986 18.3337 18.3327 14.5996 18.3327 10.0003C18.3327 5.40103 14.5986 1.66699 9.99935 1.66699C5.40006 1.66699 1.66602 5.40103 1.66602 10.0003V10.0003"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 1.66667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 5V10L13.3333 11.6667"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 1.66667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

ClockIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

ClockIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
};

export default ClockIcon;
